exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#address-header{padding-bottom:1em}#address-details{margin-bottom:2em}#address-details .column:last-of-type{margin-left:.5em}#address-verifier h5{margin-top:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4bd78482","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/orders/initial-order-setup/AddressVerifier.vue
// module id = hWPh
// module chunks = 18